import { render, staticRenderFns } from "./DeveloperHeader.vue?vue&type=template&id=fc54faf6&scoped=true&"
import script from "./DeveloperHeader.vue?vue&type=script&lang=ts&"
export * from "./DeveloperHeader.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperHeader.vue?vue&type=style&index=0&id=fc54faf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc54faf6",
  null
  
)

export default component.exports